import React from 'react';
import Icon from '../../../components/AppIcon';

const StorySection = () => {
  const storyMilestones = [
    {
      year: "2018",
      title: "The Beginning",
      description: "Started my journey in web development, driven by curiosity and a passion for solving problems through technology. Built my first production application for a local business.",
      icon: "Sparkles"
    },
    {
      year: "2019",
      title: "Skill Expansion",
      description: "Mastered full-stack development, diving deep into React, Node.js, and database architecture. Completed 15+ client projects while maintaining a 100% satisfaction rate.",
      icon: "TrendingUp"
    },
    {
      year: "2020",
      title: "Production Focus",
      description: "Shifted focus to scalable, production-grade solutions. Led development of enterprise applications serving 10,000+ users. Implemented CI/CD pipelines and performance optimization strategies.",
      icon: "Rocket"
    },
    {
      year: "2021",
      title: "Business Integration",
      description: "Began bridging technical expertise with business strategy. Consulted with startups on technical architecture decisions that directly impacted their growth trajectory and funding success.",
      icon: "Briefcase"
    },
    {
      year: "2022",
      title: "Scale & Impact",
      description: "Delivered solutions that processed $2M+ in transactions. Built systems handling 50,000+ daily active users. Established reputation for reliability and business-focused development.",
      icon: "BarChart3"
    },
    {
      year: "2023-Present",
      title: "Trusted Partner",
      description: "Now working with growth-stage startups and established agencies as their go-to technical partner. Focused on building solutions that don't just work—they drive measurable business outcomes.",
      icon: "Award"
    }
  ];

  return (
    <section className="py-16 md:py-24 lg:py-32 bg-card">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16 lg:mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 border border-primary/20 mb-4">
            <Icon name="BookOpen" size={16} className="text-primary" />
            <span className="text-sm font-medium text-primary">My Journey</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground mb-4 md:mb-6">
            From Learner to Production Builder
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-3xl mx-auto">
            My path wasn't about collecting certifications or chasing trends. It was about solving real problems, learning from production challenges, and building solutions that create tangible business value.
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-8 top-0 bottom-0 w-0.5 bg-gradient-to-b from-primary via-primary/50 to-transparent" />

          <div className="space-y-8 md:space-y-12">
            {storyMilestones?.map((milestone, index) => (
              <div key={index} className="relative pl-12 md:pl-20">
                <div className="absolute left-0 md:left-4 top-0 w-8 h-8 md:w-12 md:h-12 rounded-full bg-primary flex items-center justify-center shadow-lg">
                  <Icon name={milestone?.icon} size={16} className="text-primary-foreground md:w-6 md:h-6" />
                </div>

                <div className="bg-background rounded-xl p-6 md:p-8 border border-border hover:border-primary/50 transition-all duration-300 hover:shadow-xl">
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4 gap-2">
                    <h3 className="text-xl md:text-2xl font-bold font-heading text-foreground">
                      {milestone?.title}
                    </h3>
                    <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary text-sm font-medium w-fit">
                      <Icon name="Calendar" size={14} />
                      {milestone?.year}
                    </span>
                  </div>
                  <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                    {milestone?.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StorySection;